import { useContext } from "react";
import Button from "../ui/Button";
import { useNavigate } from "react-router-dom";
import poweredByContext from "../../store/PoweredByContext";
import envVariables from "../../data/envVariables";

const QuoteCtaBar = ({
    page,
    filtersButtonRef,
    compareButtonRef,
    showFilters,
    showCompareBar,
    showFiltersHandler,
    showCompareBarHandler,
    filterCount,
    compareSelection,
    backLink,
    clearAllHandler,
    showShare,
    sharedPage,
    legId,
    name,
}) => {
    // Hooks
    const navigate = useNavigate();
    const poweredByCtx = useContext(poweredByContext);

    // On tenant sites the icons are rendered as masks coloured by the button text,
    // so the light/dark SVG variants are irrelevant.
    const themedIcons = poweredByCtx.isPoweredBy;
    const filterIcon = poweredByCtx.isPoweredBy ? "filter-black" : "filter";
    const compareIcon = poweredByCtx.isPoweredBy ? "compare-black" : "compare";
    const downloadIcon = poweredByCtx.isPoweredBy ? "download-black" : "download";

    // Navigate to quote
    const navigateBackToQuoteHandler = () => {
        let link = `/quote${backLink}`;
        if (sharedPage) {
            link = `/shared-quote${backLink}`;
        }

        clearAllHandler();
        navigate(link);
    };

    const compareClick = () => {
        if (typeof showCompareBarHandler === "function") {
            showCompareBarHandler();
        }
    };

    const filterClick = () => {
        if (typeof showFiltersHandler === "function") {
            showFiltersHandler();
        }
    };

    const downloadClick = () => {
        window.open(`${envVariables.documentBase}/QuotebuilderDownload/download-quotebrief?lo=${legId}&name=${name}`);
    };

    const getBackToQuoteIcon = () => {
        if (poweredByCtx.isPoweredBy) {
            if (poweredByCtx.tenant.isDarkButton) {
                return "chevron-left-black";
            } else {
                return "chevron-left-light";
            }
        } else {
            return "chevron-left-light-grey";
        }
    };

    const getShareIcon = () => {
        if (poweredByCtx.isPoweredBy) {
            if (poweredByCtx.tenant.isDarkButton) {
                return "share-black";
            } else {
                return "share-light";
            }
        } else {
            return "share";
        }
    };

    return (
        <div className="quote-cta-bar wrap wrap--sm-no-padding">
            <div className="quote-cta-bar__padding">
                {page === "compare" ? (
                    <>
                        <Button
                            classNames={[
                                !poweredByCtx.isPoweredBy ? "button--white" : null,
                                "quote-cta-bar__button",
                                "quote-cta-bar__button--compare",
                                sharedPage && "quote-cta-bar__button--left-aligned",
                            ]}
                            icon={getBackToQuoteIcon()}
                            onClick={navigateBackToQuoteHandler}
                        >
                            Back to Quote
                        </Button>
                        {!sharedPage && (
                            <>
                                <div className="quote-cta-bar__divide" />
                                <Button
                                    onClick={() => showShare()}
                                    classNames={[
                                        !poweredByCtx.isPoweredBy ? "button--white" : null,
                                        "quote-cta-bar__button",
                                    ]}
                                    icon={getShareIcon()}
                                >
                                    Share {compareSelection.length} flight{compareSelection.length > 1 && "s"}
                                </Button>
                            </>
                        )}
                    </>
                ) : (
                    <>
                        <div className="quote-cta-bar__group quote-cta-bar__group--left">
                            <Button
                                ref={filtersButtonRef}
                                onClick={filterClick}
                                active={showFilters}
                                classNames={[
                                    !poweredByCtx.isPoweredBy ? "button--white" : null,
                                    "quote-cta-bar__button",
                                    "quote-cta-bar__button--filter",
                                ]}
                                icon={filterIcon}
                                themedIcon={themedIcons}
                            >
                                Filter {filterCount !== 0 && `(${filterCount})`}
                            </Button>
                        </div>
                        <div className="quote-cta-bar__group quote-cta-bar__group--right">
                            <Button
                                ref={compareButtonRef}
                                onClick={compareClick}
                                active={showCompareBar}
                                classNames={[
                                    !poweredByCtx.isPoweredBy ? "button--white" : null,
                                    "quote-cta-bar__button",
                                ]}
                                icon={compareIcon}
                                themedIcon={themedIcons}
                            >
                                Compare
                            </Button>
                            <Button
                                onClick={downloadClick}
                                classNames={[
                                    !poweredByCtx.isPoweredBy ? "button--white" : null,
                                    "quote-cta-bar__button",
                                    "quote-cta-bar__button--download",
                                ]}
                                icon={downloadIcon}
                                themedIcon={themedIcons}
                            >
                                Download
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default QuoteCtaBar;
